import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchMoveSuite = async (id) => {
  if (!id) {
    console.warn("fetchMoveSuite skipped because id is null/undefined/empty");
    return null;
  }
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getTestSuites&companyid=${user.companyid}&productid=${id}`,
  );

  return response.data;
};

const useMoveSuiteQuery = (id, enabled, options = {}) => {
  return useQuery({
    queryKey: ["moveSuite", id],
    queryFn: () => fetchMoveSuite(id),
    enabled: enabled && !!id,
    retry: true,
    staleTime: 0,
    ...options,
  });
};

export default useMoveSuiteQuery;
